import { __decorate } from "tslib";
import { observable } from '@microsoft/fast-element';
import { FoundationElement } from '@microsoft/fast-foundation';
import { logger } from '../utils';
import { foundationErrorDialogStyles as styles } from './error-dialog.styles';
import { errorDialogTemplate as template } from './error-dialog.template';
export const foundationErrorDialogShadowOptions = {
    mode: 'open',
    delegatesFocus: true,
};
/**
 * @tagname %%prefix%%-error-dialog
 * @deprecated
 */
export class ErrorDialog extends FoundationElement {
    connectedCallback() {
        super.connectedCallback();
        logger.deprecated('ErrorDialog', 'Use `${prefix}-dialog` instead.');
    }
    /**
     * Show the Error Dialog.
     */
    show() {
        this.dialog.show();
    }
    /**
     * Dismiss the Error Dialog from display and calls the dismissing action.
     */
    dismiss() {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        if ((_d = (_c = (_b = (_a = this.error) === null || _a === void 0 ? void 0 : _a.config) === null || _b === void 0 ? void 0 : _b.dialog) === null || _c === void 0 ? void 0 : _c.dismissingAction) === null || _d === void 0 ? void 0 : _d.action) {
            this.error.config.dialog.dismissingAction.action();
        }
        if ((_h = (_g = (_f = (_e = this.notification) === null || _e === void 0 ? void 0 : _e.config) === null || _f === void 0 ? void 0 : _f.dialog) === null || _g === void 0 ? void 0 : _g.dismissingAction) === null || _h === void 0 ? void 0 : _h.action) {
            this.notification.config.dialog.dismissingAction.action();
        }
        this.closeDialog();
    }
    /**
     * Dismiss the Error Dialog from display.
     */
    closeDialog() {
        try {
            this.dialog.close();
            this.remove();
        }
        catch (e) {
            logger.error(e);
        }
    }
}
__decorate([
    observable
], ErrorDialog.prototype, "error", void 0);
__decorate([
    observable
], ErrorDialog.prototype, "notification", void 0);
/**
 * The Foundation Error Dialog
 *
 * @public
 * @remarks
 * HTML Element: <foundation-error-dialog>
 */
export const foundationErrorDialog = ErrorDialog.compose({
    baseName: 'error-dialog',
    template,
    styles,
    shadowOptions: foundationErrorDialogShadowOptions,
});
